export class ResponseService {
    public static async createMessage(response: (Response), type: string): Promise<string> {
        if (response.ok) {
            return ResponseService.getValidMessage(response, type);
        } else {
            const body = await response.json();
            return `Error. ${body.detail}`;
        }
    }

    private static getValidMessage(response: (Response), type: string): string {
        if (response.status === 200) {
            return `${type} saved`;
        } else if (response.status === 201) {
            return `${type} created`;
        } else if (response.status === 204) {
            return `${type} deleted`;
        } else {
            return response.statusText;
        }
    }
}
